const doc = [({"en":({"js":({"admin":({"contacts":({"show":({"person":({"user_teams":({"this_contact_doesnt_have_a_user":"This contact doesn't have a user."})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;